<template>
    <div class="page_modal">
        <activity-modal />
        <WinningModal />
    </div>
</template>

<script>
    import ActivityModal from '@/components/modals/ActivityModal'
    import WinningModal from '@/components/modals/WinningModal'

    export default {
        components: {
            ActivityModal,
            WinningModal,
        }
    }
</script>
